import { PriorityQueue } from "@gitlode/internal-foundation/support";
function compareCommitTimestampHintedItems(left, right) {
    const leftTimestamp = left.domainHint?.sourceCommitterTimestamp;
    const rightTimestamp = right.domainHint?.sourceCommitterTimestamp;
    if (leftTimestamp === undefined && rightTimestamp === undefined)
        return 0;
    if (leftTimestamp === undefined)
        return -1;
    if (rightTimestamp === undefined)
        return 1;
    if (leftTimestamp === rightTimestamp)
        return 0;
    return leftTimestamp > rightTimestamp ? -1 : 1;
}
export function createCommitTimestampPriorityFrontier() {
    return new PriorityQueue(compareCommitTimestampHintedItems);
}
export function createCommitTimestampPhaseCertifiedStrategyOptions() {
    return {
        createDifferenceFrontier: () => createCommitTimestampPriorityFrontier(),
        createClosureFrontier: () => createCommitTimestampPriorityFrontier(),
    };
}
//# sourceMappingURL=timestamp-frontier-policy.js.map